import { cn } from '@/app/utils/cn'
import React from 'react'

interface ContainerProps {
  children: React.ReactNode
  className?: string
}

const Container: React.FC<ContainerProps> = ({ children, className }) => {
  return (
    <div className={cn('flex w-full max-w-[1048px] flex-col gap-8', className)}>
      {children}
    </div>
  )
}

export default Container
